const recipes = [];

export default recipes;
